import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nProvider } from '../shared/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../shared/layout/core';
import { MasterInit } from '../shared/layout/MasterInit';
import { useDeepLink } from './hooks/useDeepLink';

const App = () => {
  useDeepLink();

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <Outlet />
          <MasterInit />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
